import 'core-js/es7/map';
import 'core-js/es7/set';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';

ReactDOM.render(<App />, document.getElementById('app'));
